
export type GetOrderInfo500 = {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
};
